export default __webpack_public_path__ + "static/WalletConnect_PedroGomes-deae500ba8380ca62f0079e947a88be8.jpeg";